// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-pareto';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.576 16.344h16.848m-3.744-4.536v4.464h3.384v-4.464a.568.568 0 0 0-.576-.576h-2.232a.568.568 0 0 0-.576.576zM8.064 7.416v8.856h3.384V7.416a.568.568 0 0 0-.576-.576H8.64c-.36.072-.576.288-.576.576zM2.376 2.232v14.04H5.76V2.232a.568.568 0 0 0-.576-.576H2.952c-.288.072-.576.288-.576.576z' />
    <path d='M.576 16.272c.576-8.28 7.416-14.616 15.696-14.616h1.152' />
  </g>
);

export const viewBox = '0 0 18 18';
